import React from "react";
import iProps from "./props";
import "./style.less";


export const Layer: React.FC<iProps> = React.memo((props) => {
  const {
    onClick = () => {},
    children,
    visible = false,
    marginTop = 0,
  } = props;
  if (!visible) return <></>;
  return (
    <div
      className="body"
      style={{ height: `calc(100vh - ${marginTop}px)`,top:marginTop }}
      onClick={onClick}
    >
      <div className="content">
        <div onClick={(e) => e.stopPropagation()}>{children}</div>
      </div>
    </div>
  );
});

